import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {BoAutocompleteOption} from '../model/BoAutocompleteOption';

export class FieldControl {
  value: string;
  private _viewRef: AbstractDynamicFormFieldDirective;

  constructor(value: string) {
    this.value = value;
  }

  get viewRef(): AbstractDynamicFormFieldDirective {
    return this._viewRef;
  }

  set viewRef(viewRef: AbstractDynamicFormFieldDirective) {
    this._viewRef = viewRef;
    this.viewRef.writeValue0(this.value);
  }

  get isValid(): boolean {
    if (this.viewRef) {
      return this.viewRef.errors.length === 0;
    }
    return true;
  }

  setValue(value: string) {
    this.value = value;
    if (this.viewRef) {
      this.viewRef.setValue(value);
    }
  }

  closeAutoComplete() {
    if (this.viewRef) {
      this.viewRef.closeAutocomplete();
    }
  }

  showAutocompleteFor(options: BoAutocompleteOption[]) {
    if (this.viewRef) {
      this.viewRef.showAutocomplete(options);
    }
  }

  touch() {
    if (this.viewRef) {
      this.viewRef.touch();
    }
  }

  scrollToElement() {
    if (this.viewRef) {
      this.viewRef.scrollToElement();
    }
  }
}
